export default "__VITE_ASSET__Dm$1p8rH__"